import * as loginConstants from './constants'

export default (state = {}, action) => {
    switch (action.type) {
        case loginConstants.LOGIN_START:
            return {
                loading: true,
            }
        case loginConstants.LOGIN_SUCCESS: {
            const { token, username } = action.payload
            localStorage.setItem('pulsarBotPlatform_operatorToken', token)
            localStorage.setItem('pulsarBotPlatform_operatorUsername', username)

            return {
                token,
                loading: false,
            }
        }
        case loginConstants.LOGIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        default:
            throw new Error('Should not enter here')
    }
}
